import { call, put, select, takeEvery } from "redux-saga/effects";
import InvoiceTemplateService from "services/invoiceTemplateService";
import { errorMessage } from "helpers/utils";

import {
  GET_LIST_INVOICE_TEMPLATE,
  GET_LIST_ROOT_INVOICE_TEMPLATE,
  GET_DETAIL_INVOICE_TEMPLATE,
  CREATE_INVOICE_TEMPLATE,
  UPDATE_INVOICE_TEMPLATE,
  DELETE_INVOICE_TEMPLATE,
  GET_LIST_INVOICE_TYPE,
} from "./actionTypes";

import {
  getListInvoiceTemplateSuccess,
  getListInvoiceTemplateFail,
  getListRootInvoiceTemplateSuccess,
  getListRootInvoiceTemplateFail,
  getDetailInvoiceTemplateSuccess,
  getDetailInvoiceTemplateFail,
  createInvoiceTemplateSuccess,
  createInvoiceTemplateFail,
  updateInvoiceTemplateSuccess,
  updateInvoiceTemplateFail,
  deleteInvoiceTemplateSuccess,
  deleteInvoiceTemplateFail,
  getListInvoiceTypeSuccess,
  getListInvoiceTypeFail,
} from "./actions";

function* getListInvoiceTemplate({ payload }) {
  try {
    const buStoreHeader = localStorage.getItem("BU_TENANT_HEADER");
    const response = yield call(
      InvoiceTemplateService.listInvoiceTemplate,
      payload,
      buStoreHeader
    );
    yield put(getListInvoiceTemplateSuccess(response));
  } catch (error) {
    yield put(getListInvoiceTemplateFail(errorMessage(error)));
  }
}

function* getListInvoiceType({ payload }) {
  try {
    const buStoreHeader = localStorage.getItem("BU_TENANT_HEADER");
    const response = yield call(
      InvoiceTemplateService.listInvoiceType,
      payload.businessUnitId,
      buStoreHeader
    );
    yield put(getListInvoiceTypeSuccess(response));
  } catch (error) {
    yield put(getListInvoiceTypeFail(errorMessage(error)));
  }
}

function* getListRootInvoiceTemplate({ payload }) {
  try {
    const buStoreHeader = localStorage.getItem("BU_TENANT_HEADER");
    const response = yield call(
      InvoiceTemplateService.listInvoiceTemplate,
      payload,
      buStoreHeader
    );
    yield put(getListRootInvoiceTemplateSuccess(response));
  } catch (error) {
    yield put(getListRootInvoiceTemplateFail(errorMessage(error)));
  }
}

function* getDetailInvoiceTemplate({ payload }) {
  try {
    const response = yield call(
      InvoiceTemplateService.getDetailInvoiceTemplate,
      payload
    );
    yield put(getDetailInvoiceTemplateSuccess(response));
  } catch (error) {
    yield put(getDetailInvoiceTemplateFail(errorMessage(error)));
  }
}

function* createInvoiceTemplate({ payload }) {
  try {
    const buStoreHeader = localStorage.getItem("BU_TENANT_HEADER");
    const response = yield call(
      InvoiceTemplateService.createInvoiceTemplate,
      payload,
      buStoreHeader
    );
    yield put(createInvoiceTemplateSuccess(response));
  } catch (error) {
    yield put(createInvoiceTemplateFail(errorMessage(error)));
  }
}

function* updateInvoiceTemplate({ payload }) {
  try {
    const response = yield call(
      InvoiceTemplateService.updateInvoiceTemplate,
      payload
    );
    yield put(updateInvoiceTemplateSuccess(response));
  } catch (error) {
    yield put(updateInvoiceTemplateFail(errorMessage(error)));
  }
}

function* deleteInvoiceTemplate({ payload }) {
  try {
    const response = yield call(
      InvoiceTemplateService.deleteInvoiceTemplate,
      payload.id
    );
    yield put(deleteInvoiceTemplateSuccess(response));
  } catch (error) {
    yield put(deleteInvoiceTemplateFail(errorMessage(error)));
  }
}

function* invoiceTemplateSaga() {
  yield takeEvery(GET_LIST_INVOICE_TEMPLATE, getListInvoiceTemplate);
  yield takeEvery(GET_LIST_ROOT_INVOICE_TEMPLATE, getListRootInvoiceTemplate);
  yield takeEvery(GET_DETAIL_INVOICE_TEMPLATE, getDetailInvoiceTemplate);
  yield takeEvery(CREATE_INVOICE_TEMPLATE, createInvoiceTemplate);
  yield takeEvery(UPDATE_INVOICE_TEMPLATE, updateInvoiceTemplate);
  yield takeEvery(DELETE_INVOICE_TEMPLATE, deleteInvoiceTemplate);
  yield takeEvery(GET_LIST_INVOICE_TYPE, getListInvoiceType);
}

export default invoiceTemplateSaga;
